import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { FullPageMessage } from '@/components/full-page-message'

export const Route = createRootRoute({
  component: Outlet,
  notFoundComponent: NotFound,
})

function NotFound() {
  const { t } = useTranslation()

  return <FullPageMessage title={t('notFound.title')} body={t('notFound.body')} />
}
